import { render, staticRenderFns } from "./common-vpn-problems.vue?vue&type=template&id=2c30b436&scoped=true"
import script from "./common-vpn-problems.vue?vue&type=script&lang=js"
export * from "./common-vpn-problems.vue?vue&type=script&lang=js"
import style0 from "./common-vpn-problems.vue?vue&type=style&index=0&id=2c30b436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30b436",
  null
  
)

export default component.exports